import { Injectable } from "@angular/core";
import { KeyValue } from "../interface/upplm.placard";
import { PlacardDetails } from "../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../pipes/translation.pipe";

@Injectable()

export class PlacardSizeService {

    constructor(private _translate: TranslateDataPipe) {}

    getPlacardSize(placardDetails: PlacardDetails): string {
        if (placardDetails.placardSize && placardDetails.placardSize.includes('Portrait')) {
            return placardDetails.placardSize.replace("Portrait", this._translate.transform('upplm.placarddetails.portrait'));
        } else if (placardDetails.placardSize && placardDetails.placardSize.includes('Landscape')) {
            return placardDetails.placardSize.replace("Landscape", this._translate.transform('upplm.placarddetails.landscape'))
        }
    }

    getPlacardSizeByKeyValue(placardSizes: KeyValue[]): KeyValue[] {
        let translatedPlacardSize: KeyValue[] = [];
        placardSizes.forEach(placardSize => {
            let keyvalue = new KeyValue();
            keyvalue.key = placardSize.key;

            if (placardSize.value.includes('Portrait')) {
                keyvalue.value = placardSize.value.replace("Portrait", this._translate.transform('upplm.placarddetails.portrait'));
            } else if (placardSize.value.includes('Landscape')) {
                keyvalue.value = placardSize.value.replace("Landscape", this._translate.transform('upplm.placarddetails.landscape'))
            }
            translatedPlacardSize.push(keyvalue);
        });
        return translatedPlacardSize;
    }
}